import { ProgramProduct } from "@types";
import Link from "next/link";
import { toFarsiNumber } from "@utils/digits";
import Image from "next/image";
import Button from "@shared/components/button/Button";
import { BUTTON_SIZE, BUTTON_VARIANT } from "@shared/components/button/types";
import IconBackArrow from "@svg/header/back-arrow";
import { FC } from "react";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import { IconButton } from "@shared/components/icon-button";
import { ICON_SIZE } from "@shared/components/icon-button/types";

interface props {
  content: ProgramProduct;
}
const ProgramItemContent: FC<props> = ({ content }) => {
  const isMobile = useIsMobile();
  const theHref = `/courses/${content.slug}`;
  return (
    <Link href={theHref} target="_blank" prefetch={false}>
      <div className="flex items-center justify-between py-1.5  px-2  bg-fds-primary rounded-8 md:rounded-12 gap-3  border border-transparent hover:border-fds-brand-light">
        <div className="flex grow items-center gap-2  overflow-hidden">
          {content.photoUrl ? (
            <div className="min-w-16 flex items-center">
              <Image
                className="rounded-4 h-16 object-cover min-w-16"
                width={63}
                height={48}
                src={content.photoUrl}
                alt={content.name}
              />
            </div>
          ) : null}
          <p className="title-sm md:title-md-medium text-fds-secondary line-clamp-2 lg:line-clamp-1">
            {toFarsiNumber(content.name)}
          </p>
        </div>
        {isMobile ? (
          <IconButton
            iconClassName="rotate-180 text-fds-icon-brand w-4    "
            icon={<IconBackArrow />}
            size={ICON_SIZE.MEDIUM}
            aria-label="شروع یادگیری"
          />
        ) : (
          <Button
            variant={BUTTON_VARIANT.TEXT_ACTION}
            endIcon={<IconBackArrow className="rotate-180" />}
            size={BUTTON_SIZE.MEDIUM}
            className="min-w-fit pl-1"
          >
            شروع یادگیری
          </Button>
        )}
      </div>
    </Link>
  );
};

export default ProgramItemContent;
